import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import { type SmsSection } from '../../../types'

const textBuilderQueue = useBuilder('textBuilder')

const TextCommands = {
  updateBlock: textBuilderQueue.createBlockCommand<SmsSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { TextCommands }
